import styled from 'styled-components';
import { breakpoints, css } from 'src/styles/theme';
import { SummaryOptionsStyled } from '../SummaryOptionsStyled';
import { rem } from 'polished';

export const SummaryOptionsStyledDS = styled(SummaryOptionsStyled)`
    &.withBorder {
        border-top: ${rem(1)} solid ${({ theme }) => theme.colors.secondary};
    }

    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.h4};
            text-transform: uppercase;
        }

        .isClose {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
        }

        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }

    .optionsWrapper {
        .next-btn,
        .back-btn {
            border: 1px solid;
            border-radius: ${rem(5)};

            &:disabled {
                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.grey3};
                        stroke: ${({ theme }) => theme.colors.white};
                    }
                }
            }

            &:not(:disabled) {
                border-color: ${({ theme }) => theme.colors.black};
            }

            &:not(:disabled):hover,
            &:not(:disabled):focus-visible {
                background: ${({ theme }) => theme.colors.grey4};
                border-color: ${({ theme }) => theme.colors.primary};

                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.primary};
                        stroke: ${({ theme }) => theme.colors.grey4};
                    }
                }
            }
        }
    }
`;
